import React from "react";
import { Box, Button, Container, Grid, Stack, TextField, Typography } from "@mui/material";
import { Store } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { brand } from "../data/estoreContent";
import { ESTORE_ROUTES } from "../data/estorePaths";

function EstoreFooter() {
  const navigate = useNavigate();

  return (
    <Box component="footer" sx={{ py: 6, bgcolor: "#0F172A", color: "#F8FAFC" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: 2,
                  display: "grid",
                  placeItems: "center",
                  background: `linear-gradient(135deg, ${brand.accent} 0%, ${brand.accent2} 100%)`,
                }}
              >
                <Store size={20} color="#fff" />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 800 }}>
                {brand.name}
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: "rgba(248,250,252,0.65)", lineHeight: 1.7, maxWidth: 320 }}>
              EStore shop, bag, checkout, and account live entirely on Estore routes — separate from the legacy e‑commerce module.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 2, letterSpacing: "0.06em" }}>
              Shop
            </Typography>
            <Stack spacing={1}>
              <Button color="inherit" sx={{ justifyContent: "flex-start", textTransform: "none", opacity: 0.85 }} onClick={() => navigate("/Estore")}>
                Home
              </Button>
              <Button color="inherit" sx={{ justifyContent: "flex-start", textTransform: "none", opacity: 0.85 }} onClick={() => navigate("/ShopPage")}>
                Catalog
              </Button>
              <Button color="inherit" sx={{ justifyContent: "flex-start", textTransform: "none", opacity: 0.85 }} onClick={() => navigate("/CartPage")}>
                Cart
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 2, letterSpacing: "0.06em" }}>
              Account
            </Typography>
            <Stack spacing={1}>
              <Button color="inherit" sx={{ justifyContent: "flex-start", textTransform: "none", opacity: 0.85 }} onClick={() => navigate(ESTORE_ROUTES.account)}>
                Account
              </Button>
              <Button color="inherit" sx={{ justifyContent: "flex-start", textTransform: "none", opacity: 0.85 }} onClick={() => navigate(ESTORE_ROUTES.checkout)}>
                Checkout
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 2, letterSpacing: "0.06em" }}>
              Stay in the loop
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              <TextField
                size="small"
                placeholder="Email address"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "rgba(255,255,255,0.06)",
                    borderRadius: 2,
                    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
                  },
                  input: { color: "#fff" },
                }}
              />
              <Button variant="contained" sx={{ fontWeight: 800, textTransform: "none", borderRadius: 2, whiteSpace: "nowrap" }}>
                Notify me
              </Button>
            </Stack>
          </Grid>
        </Grid>
        <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.08)", mt: 5, pt: 3, textAlign: "center" }}>
          <Typography variant="caption" sx={{ color: "rgba(248,250,252,0.45)" }}>
            © {new Date().getFullYear()} {brand.name}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default EstoreFooter;
